import React, { useState } from 'react';
import MissionDebugPanel from './MissionDebugPanel';
import { isDebugEnabled } from '../../config/environment';

interface MissionDebugWrapperProps {
  children: React.ReactNode;
}

/**
 * Wraps mission content and provides a toggle button (in development)
 * to show/hide the MissionDebugPanel.
 * Manages the visibility state internally.
 * Must be used within a MissionDebugProvider.
 */
const MissionDebugWrapper: React.FC<MissionDebugWrapperProps> = ({ children }) => {
  const [showDebug, setShowDebug] = useState<boolean>(false);

  // Styles for the toggle button (could be moved to a CSS module)
  const toggleButtonStyle: React.CSSProperties = {
    position: 'fixed',
    bottom: '15px',
    right: '15px',
    zIndex: 1050,
    background: showDebug ? '#dc3545' : '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    fontSize: '20px',
    lineHeight: '40px',
    textAlign: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
    transition: 'background-color 0.2s ease',
  };

  return (
    <>
      {/* Render the actual mission content passed as children */} 
      {children}

      {/* --- Debug Panel Toggle --- */} 
      {isDebugEnabled() && (
        <button
          onClick={() => setShowDebug(s => !s)}
          style={toggleButtonStyle}
          title={showDebug ? 'Hide Mission Debug Panel' : 'Show Mission Debug Panel'}
          data-testid="toggle-mission-debug-panel"
        >
          🎯
        </button>
      )}

      {/* --- Debug Panel Rendering --- */}
      {showDebug && <MissionDebugPanel onClose={() => setShowDebug(false)} />}
    </>
  );
};

export default MissionDebugWrapper; 